import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/mobile.css';
import App from './App';
import { registerWebMcpTools } from './webmcp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const webMcpAbort = new AbortController();
void registerWebMcpTools(webMcpAbort.signal);
window.addEventListener('pagehide', () => webMcpAbort.abort(), { once: true }); 